
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';

const { productCategory } = api;

@Component({
  components: { },
})
export default class swapOutProductCategory extends Vue {
  private data = { data: [] };

  private headers = [
    { text: 'ID', value: 'catId' },
    { text: '名稱', value: 'catName' },
    { text: '排序', value: 'sort' },
    { text: '修改', value: 'edit', sortable: false },
    { text: '刪除', value: 'delete', sortable: false },
  ];

  private get collection() {
    return [...(this.data.data || [])];
  }

  private async handleOpenDelete(catId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await productCategory.delete(catId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private async requestData() {
    const data = await productCategory.list();
    this.data = data;
  }

  private async created() {
    await this.requestData();
  }
}
